'use client'

import PropTypes from 'prop-types'
import { LargeNotesIcon } from '@repo/ui/LargeNotesIcon'
import { MatterSelect } from '@repo/ui/MatterSelect'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useThirdPartyFormWizardStore } from '@repo/store/useThirdPartyFormWizardStore'
import { WizardFooter } from '@repo/ui/WizardFooter'
import { WizardFormSection } from '@repo/ui/WizardFormSection'
import { WizardIconTitle } from '@repo/ui/WizardIconTitle'
import { WizardPanel } from '@repo/ui/WizardPanel'
import MUITypography from '@mui/material/Typography'

const FORM_PROVIDER_OPTIONS = [{ value: 'FormEvo', label: 'FormEvo' }]

export const ThirdPartyFormSelectOptions = ({ updateStepState, wideMode, handlePrevNext, currentStep }) => {
  const { selectedMatter, formProvider, updateState } = useThirdPartyFormWizardStore()

  const selectedProviderOption =
    FORM_PROVIDER_OPTIONS.find((option) => option.value === formProvider) ?? FORM_PROVIDER_OPTIONS[0]

  const handleClickContinue = () => {
    updateStepState({ status: 'completed', statusText: selectedMatter?.clientMatterNo })
    handlePrevNext(1)
  }

  return (
    <>
      <WizardPanel data-testid="ThirdPartyFormSelectOptions">
        <WizardFormSection>
          <WizardIconTitle title="Select options" icon={LargeNotesIcon} sx={{ mb: 6, width: '100%' }} />

          <MUITypography variant="body1" sx={{ width: '100%', mb: 4 }}>
            This wizard will help you create a new third-party form, and populate it with Osprey data.
          </MUITypography>

          <MatterSelect
            size="medium"
            sx={{ width: '100%', maxWidth: '486px' }}
            value={selectedMatter}
            onChange={(value) => updateState({ key: 'selectedMatter', value })}
            name="matter"
            required
          />

          <ReactSelectMenu
            label="Form provider"
            name="formProvider"
            size="medium"
            sx={{ width: '100%', maxWidth: '486px' }}
            items={FORM_PROVIDER_OPTIONS}
            value={selectedProviderOption}
            valueKey="value"
            labelKey="label"
            searchable={false}
            clearable={false}
            required
            onChange={(option) => updateState({ key: 'formProvider', value: option?.value ?? null })}
          />
        </WizardFormSection>
      </WizardPanel>

      <WizardFooter
        wideMode={wideMode}
        handleClickContinue={handleClickContinue}
        continueButtonText="Select form"
        backButtonVisible={currentStep?.index !== 0}
        continueButtonDisabled={!selectedMatter}
      />
    </>
  )
}

ThirdPartyFormSelectOptions.propTypes = {
  updateStepState: PropTypes.func,
  wideMode: PropTypes.bool,
  handlePrevNext: PropTypes.func,
  currentStep: PropTypes.object
}
